import util from '../util'

let controller = 'AdministradorConta'
export default Object.assign({}, util.GetCrud(controller, null), {
})
